export const AUTOFILL_IGNORE_DATA_PROPS = {
  "data-lpignore": "true",
  "data-1p-ignore": "true",
  "data-bwignore": "true",
};

export const FORM_AUTOFILL_PROPS = {
  autoComplete: "off",
  ...AUTOFILL_IGNORE_DATA_PROPS,
};

export const INPUT_AUTOFILL_PROPS = {
  autoComplete: "new-password",
  ...AUTOFILL_IGNORE_DATA_PROPS,
};

export const SELECT_AUTOFILL_PROPS = {
  autoComplete: "off",
  ...AUTOFILL_IGNORE_DATA_PROPS,
};

export const mergeAutofillProps = (props = {}, defaults = INPUT_AUTOFILL_PROPS) => ({
  ...defaults,
  ...(props || {}),
});
